var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 74C57.8823 74 74 57.8823 74 38C74 18.1177 57.8823 2 38 2C18.1177 2 2 18.1177 2 38C2 57.8823 18.1177 74 38 74Z",
    stroke: "#FF5252",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25 27.5H25.75H53.75",
    stroke: "#EC4C47",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 27.5V24C31 23.0717 31.3687 22.1815 32.0251 21.5251C32.6815 20.8687 33.5717 20.5 34.5 20.5H41.5C42.4283 20.5 43.3185 20.8687 43.9749 21.5251C44.6313 22.1815 45 23.0717 45 24V27.5M50.25 27.5V52C50.25 52.9283 49.8813 53.8185 49.2249 54.4749C48.5685 55.1313 47.6783 55.5 46.75 55.5H29.25C28.3217 55.5 27.4315 55.1313 26.7751 54.4749C26.1187 53.8185 25.75 52.9283 25.75 52V27.5H50.25Z",
    stroke: "#EC4C47",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 36.25V46.75",
    stroke: "#EC4C47",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5 36.25V46.75",
    stroke: "#EC4C47",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinIcon);
export default __webpack_public_path__ + "static/media/bin_icon.884822482780897e40b6b80767f5a6be.svg";
export { ForwardRef as ReactComponent };